import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8ba9578"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "additional-options-block" }
const _hoisted_2 = {
  key: 0,
  class: "title_green"
}
const _hoisted_3 = {
  key: 1,
  class: "title_green"
}
const _hoisted_4 = {
  key: 0,
  class: "additional-options-block-wrapper"
}
const _hoisted_5 = { class: "additional-options-block__title" }
const _hoisted_6 = { class: "additional-options-block__options" }

import { onMounted, ref, Ref } from 'vue';
import { useSearchStore } from "@/searchSection/store/searchStore";
import api from "@/searchSection/api";
import { GroupAdditionalOption } from '@/searchSection/types/AdditionalOption';
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue';
import ArrowIcon from '@/common/icons/ArrowIcon.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalOptionsBlock',
  props: {
    visibleFiltersAdditionalOptions: { type: Boolean }
  },
  emits: ['toggleFilter'],
  setup(__props: any, { emit: __emit }) {

const searchStore = useSearchStore()

const emit = __emit;
const additionalOptions: Ref<GroupAdditionalOption[]> = ref([]);

function toggleAdditionalOption(optionId: number) {
  if (searchStore.searchOptions.additionalOptions.includes(optionId)) {
    searchStore.searchOptions.additionalOptions = searchStore.searchOptions.additionalOptions.filter(id => id !== optionId);
  } else {
    searchStore.searchOptions.additionalOptions.push(optionId);
  }
}

onMounted(async () => {
  try {
    const additionalOptionsResponse = await api.getAdditionalOptions()
    additionalOptions.value = additionalOptionsResponse
  } catch (e) {
    window.showNotification('Произошла ошибка!', 'error')
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "additional-options-block__title title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggleFilter')))
    }, [
      _createTextVNode(" Оказываемые услуги "),
      (_unref(searchStore).additionalOptionsFilters)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Указаны " + _toDisplayString(_unref(searchStore).additionalOptionsFilters) + " параметр ", 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, " Не указаны ")),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(["title__arrow", { 'title__arrow_active': _ctx.visibleFiltersAdditionalOptions }])
      }, null, 8 /* PROPS */, ["class"])
    ]),
    _createVNode(_Transition, { name: "fade-slide" }, {
      default: _withCtx(() => [
        (_ctx.visibleFiltersAdditionalOptions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalOptions.value, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "additional-options-block__element",
                  key: group.id
                }, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(group.name), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.additionalOptions, (option) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "additional-options-block__option",
                        key: option.id
                      }, [
                        _createVNode(pCheckbox, {
                          modelValue: _unref(searchStore).searchOptions.additionalOptions.includes(option.id),
                          label: option.name,
                          "onUpdate:modelValue": ($event: any) => (toggleAdditionalOption(option.id))
                        }, null, 8 /* PROPS */, ["modelValue", "label", "onUpdate:modelValue"])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})